import {useTranslation} from 'react-i18next';
import {VERIFICATION_METHODS} from '@chekin/api';
import {ContactsVerificationCodes} from './components/ContactsVerificationCodes';
import {PhoneInput} from './components/ContactsForm/PhoneInput';
import {ContactsForm} from './components/ContactsForm';
import {PageWrapper} from './components/PageWrapper';
import {useVerification} from './useVerification';
import {VerificationStep} from './constants';
import {FormTypes} from './types';
import {getPhoneNumberString} from '@chekin/core';

type Props = {
  currentStep: VerificationStep;
  onGenerate?: () => void;
  onVerify?: (data: string, isVerified: boolean) => void;
  onChangeContacts?: () => void;
};

const PhoneVerification = ({
  currentStep,
  onGenerate = () => {},
  onVerify = () => {},
  onChangeContacts = () => {},
}: Props) => {
  const {t} = useTranslation();

  const {isLoading, contactsData, resendCode, verifyCode, onSubmit} = useVerification({
    type: VERIFICATION_METHODS.phone,
    onGenerate,
    onVerify,
    isMock: import.meta.env.DEV,
  });

  const handleSubmit = (data: FormTypes) => {
    return onSubmit(getPhoneNumberString(data?.phone) || '');
  };

  return (
    <PageWrapper
      title={
        currentStep === VerificationStep.CONTACTS_INPUT ? t('verify_your_phone') : ''
      }
      subtitle={t('contacts_verification_info')}
    >
      {currentStep === VerificationStep.CODES_VERIFICATION && (
        <ContactsVerificationCodes
          title={t('enter_code', {type: t('sms')})}
          sentToValue={contactsData}
          type={VERIFICATION_METHODS.phone}
          onVerifyCodes={verifyCode}
          onResendCodes={resendCode}
          onChangeContacts={onChangeContacts}
          isLoading={isLoading}
        />
      )}
      {currentStep === VerificationStep.CONTACTS_INPUT && (
        <ContactsForm
          type={VERIFICATION_METHODS.phone}
          isLoading={isLoading}
          onSubmit={handleSubmit}
        >
          <PhoneInput name="phone" label={t('phone_number')} />
        </ContactsForm>
      )}
    </PageWrapper>
  );
};

export {PhoneVerification};
